import React, {Component} from "react";
import InputField from "../Field";
import {Drawer, Grid} from "@material-ui/core";
import {Form, Formik} from "formik";
import * as Yup from "yup";
import IconButton from "@material-ui/core/IconButton/IconButton";
import Cuisines from "../../components/CuisinesAutocomplete";
import DishesAutoComplete from '../../components/CuisinesAutocomplete/DishAutoComplete';
import {AddCircle, Close} from "@material-ui/icons";
import {NotificationManager} from "react-notifications";
import Button from "@material-ui/core/Button/Button";
import {primaryColor, webFont} from "../../config/theme";
import {connect} from "react-redux";
import {getChefFilters, setChefFilters} from "../../redux/chefs";
import { CUISINES } from "../../graphql/queries/dishes/index";
import { client } from '../../config/apollo';

const SearchSchema = Yup.object().shape({
  city: Yup.string().required("Please enter City")
});

class ChefFilters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      distance: 100,
      canFly: false,
      cuisines: [],
      cuisine: "",
      dishes: [],
      dish: "",
      price: 50,
      priceMin: 50,
      priceMax: 1000,
      engagement: 1,
      list: []
    };
  }

  addCuisine = () => {
    const {cuisines, cuisine, list} = this.state;

    if(cuisine.trim().length<=0)
      return;

    if (!list.find(c => c.toLowerCase() === cuisine.toLowerCase())) {
      NotificationManager.error("For any new cuisines to be added in the list, please make a feature request in Feedback under Account", "Cuisines", 4000);
      return;
    }

    if (cuisines.find(c => c === cuisine)) {
      NotificationManager.error(cuisine + " is already selected", "Cuisines");
      return;
    }
    cuisines.push(cuisine);
    this.setState({cuisines, cuisine: ""});
  };

  removeCuisine = (cuisine) => {
    const { cuisines } = this.state;
    const cuisineIndex = cuisines.findIndex(c => c.toLowerCase() === cuisine.toLowerCase());
    if (cuisineIndex > -1) {
      cuisines.splice(cuisineIndex, 1);
      this.setState({ cuisines })
    }
  };

  componentDidMount() {
    const {chefFilters, dispatch} = this.props;
    dispatch(getChefFilters());
    if (!!chefFilters) {
      const {
        cuisines: chefCuisines,
        dishes: chefDishes,
        price,
        engagement,
        priceMin,
        priceMax,
      } = chefFilters;

      const {cuisines, dishes} = this.state;

      this.setState({
        cuisines: chefCuisines && chefCuisines.length ? chefCuisines : cuisines,
        dishes: chefDishes && chefDishes.length ? chefDishes : dishes,
        price: price,
        priceMin: priceMin || 50,
        priceMax: priceMax || 1000,
        engagement
      });

      if ((chefCuisines && chefCuisines.length > 0) || (chefDishes && chefDishes.length > 0) || engagement > 1) {
        this.props.onApplyFilters(chefFilters);
      }
    }

    try {
      client.query({
        query: CUISINES,
        variables: {
          country: "US"
        },
      }).then(response => {
        const { data } = response;
        this.setState({ list: data.cuisines });
      });
    } catch(err) {}
  }

  addDish = () => {
    const {dishes, dish} = this.state;

    if(dish.trim().length<=0)
      return;

    if (dishes.find(d => d === dish)) {
      NotificationManager.error(dish + " is already selected", "Dishes");
      return;
    }
    dishes.push(dish);
    this.setState({dishes, dish: ""});
  };

  removeDish = (dish) => {
    const { dishes } = this.state;
    const dishIndex = dishes.findIndex(d => d === dish);
    if (dishIndex > -1) {
      dishes.splice(dishIndex, 1);
      this.setState({ dishes })
    }
  }

  handleEngagementChange = value => {
    this.setState({engagement: value});
  };

  handlePriceChange = value => {
    this.setState({price: value});
  };

  clearFilters = () => {
    const {dispatch} = this.props;
    const filters = {
      engagement: 1,
      price: 50,
      dishes: [],
      cuisines: [],
      priceMin: 50,
      priceMax: 1000,
    };
    dispatch(setChefFilters(filters));
    this.setState({
      engagement: 1,
      price: 50,
      dishes: [],
      cuisines: [],
      cuisine: "",
      dish: "",
      priceMin: 50,
      priceMax: 1000,
    });
    this.props.onApplyFilters(filters);
    this.props.closeFilters();
  };

  applyFilters = () => {
    const {engagement, priceMin, priceMax, dishes, cuisines} = this.state;
    const {dispatch, chefFilters} = this.props;

    if (chefFilters) {
      this.setState(
        {
          engagement: chefFilters.engagement,
          priceMin: chefFilters.priceMin ? chefFilters.priceMin : 50,
          priceMax: chefFilters.priceMax ? chefFilters.priceMax : 1000,
          dishes: chefFilters.dishes,
          cuisines: chefFilters.cuisines
        },
        () => {
          const filters = {engagement, priceMin, priceMax, dishes, cuisines};
          dispatch(setChefFilters(filters));
          this.props.onApplyFilters(filters);
        }
      );
    } else {
      const filters = {engagement, priceMin, priceMax, dishes, cuisines};
      dispatch(setChefFilters(filters));
      this.props.onApplyFilters(filters);
    }
    this.props.closeFilters();
  };

  render() {
    return (
      <Grid style={{width: 270}}>
        <Grid item md={12}>
          <div style={{
            position: 'fixed',
            top: 13,
            left: 350,
            cursor: 'pointer'
          }} onClick={this.props.closeFilters}>
            <Close />
          </div>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 24,
            fontWeight: '600',
            fontFamily: webFont,
          }}>
            Filters
          </div>
          <div
            style={{
              paddingTop: 10,
              display: "flex",
              justifyContent: "space-between",
              paddingBottom: 20
            }}
          >
            <div>
              <Button
                data-test-id={"cheffilapply"}
                style={{
                  fontFamily: webFont,
                  textTransform: "none",
                  fontSize: 16,
                  padding: '5px 20px',
                  color: '#fff',
                  backgroundColor: '#ff8000',
                  borderRadius: 40,
                }}
                onClick={() => this.applyFilters()}
              >
                Apply
              </Button>
            </div>
            <Button
              data-test-id={"cheffilclr"}
              style={{
                fontFamily: webFont,
                textTransform: "none",
                fontSize: 16,
                padding: '5px 20px',
                color: '#fff',
                backgroundColor: '#ff8000',
                borderRadius: 40,
              }}
              onClick={() => this.clearFilters()}
            >
              Clear
            </Button>
          </div>
        </Grid>
        <Grid item>
          <Formik
            initialValues={{city: ""}}
            enableReinitialize
            validationSchema={SearchSchema}
          >
            {({errors, touched}) => (
              <Form>
                <Grid container>
                  <Grid container alignItems='top' direction='row'>
                    <Grid item lg={11} sm={10} xs={10}>
                      <Cuisines
                        onItemSelected={value => {
                          this.setState({ cuisine: value });
                        }}
                        onChange={value => {
                          this.setState({ cuisine: value });
                        }}
                        value={this.state.cuisine}
                      />
                    </Grid>
                    <Grid item lg={1} sm={2} xs={2} style={{marginTop: 20}}>
                      <IconButton
                      data-test-id={"addcuisbtna"}
                        style={{marginTop: -10, marginLeft: -15}}
                        disabled={!this.state.cuisine.length}
                        onClick={() => this.addCuisine()}
                      >
                        <AddCircle  data-test-id={"addcuisbtn"} color="primary"/>
                      </IconButton>
                    </Grid>
                  </Grid>

                  <Grid item  xs={12} style={{marginBottom: 20}}>
                    {this.state.cuisines &&
                    this.state.cuisines.map(cuisine => (
                      <Button
                        data-test-id={"enteredcuis"}
                        key={cuisine}
                        variant={"outlined"}
                        color={"primary"}
                        style={{
                          height: "32px",
                          borderRadius: "20px",
                          margin: 5
                        }}
                        size={"small"}
                        onClick={() => this.removeCuisine(cuisine)}
                      >
                        {cuisine}
                      </Button>
                    ))}
                  </Grid>

                  <Grid container alignItems='top' direction='row'>
                    <Grid item lg={11} sm={10} xs={10}>
                      <DishesAutoComplete
                        onItemSelected={value => {
                          this.setState({ dish: value });
                        }}
                        onChange={value => {
                          this.setState({ dish: value });
                        }}
                        value={this.state.dish}
                      />
                    </Grid>
                    <Grid item lg={1} sm={2} xs={2} style={{marginTop: 20}}>
                      <IconButton
                      data-test-id={"adddishbtna"}
                        style={{marginTop: -10, marginLeft: -15}}
                        disabled={!this.state.dish.length}
                        onClick={() => this.addDish()}
                      >
                        <AddCircle data-test-id={"adddishbtn"}  color="primary"/>
                      </IconButton>
                    </Grid>
                  </Grid>

                  <Grid item  xs={12} style={{marginBottom: 20}}>
                    {this.state.dishes &&
                    this.state.dishes.map(dish => (
                      <Button
                        key={dish}
                        variant={"outlined"}
                        color={"primary"}
                        style={{
                          height: "32px",
                          borderRadius: "20px",
                          margin: 5
                        }}
                        size={"small"}
                        onClick={() => this.removeDish(dish)}
                      >
                        {dish}
                      </Button>
                    ))}
                  </Grid>

                  <Grid data-test-id={"priceflt-btn"} item xs={12}>
                    <Grid
                      container
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Grid>
                        <p  style={style.label}>Price range</p>
                      </Grid>
                      <Grid style={{ marginTop: 18 }}> $
                        <input
                        data-test-id={"apriceflt-btn"}
                          value={this.state.priceMin ? this.state.priceMin.toString() : ''}
                          onChange={evt => {
                            let priceMin = evt.target.value;

                            if (priceMin.length > 0) {
                              priceMin = parseInt(priceMin);
                              if (isNaN(priceMin)) {
                                NotificationManager.error('Only numbers are allowed', 'Chef filters');
                                return;
                              }

                              /*if (priceMin < 50 && priceMin.toString().length > 1) {
                                NotificationManager.error('Price cannot be less than 50', 'Chef filters');
                                this.setState({ priceMin });
                                return;
                              }*/

                              if (priceMin <= this.state.priceMax) {
                                let priceMax = priceMin + 1000;
                                this.setState({ priceMax });
                              }

                              this.setState({ priceMin });
                            } // end-if price min length > 0
                            else {
                              this.setState({ priceMin: "" });
                            }
                          }}
                          onBlur={() => {
                            let priceMin = this.state.priceMin;

                            if (priceMin.length <= 0) {
                              priceMin = 50;
                            }

                            if (priceMin < 50) {
                              priceMin = 50;
                            }

                            this.setState({ priceMin });
                          }}
                          style={style.priceRangeInput}
                        />

                        <span style={style.toLabel}> to </span>

                        $<input
                        data-test-id={"bpriceflt-btn"}
                          value={this.state.priceMax ?  this.state.priceMax.toString() : ''}
                          onChange={evt => {
                            let priceMax = evt.target.value;

                            if (priceMax.length > 0) {
                              priceMax = parseInt(priceMax);
                              if (isNaN(priceMax)) {
                                NotificationManager.error('Only numbers are allowed', 'Chef filters');
                                priceMax = this.state.priceMin + 1000;
                              }

                              this.setState({ priceMax });
                            } // end-if price max length > 0
                            else {
                              this.setState({ priceMax });
                            }
                          }}
                          onBlur={() => {
                            let priceMax = this.state.priceMax;

                            if (priceMax <= this.state.priceMin) {
                              priceMax = this.state.priceMin + 1000;
                            }

                            this.setState({ priceMax });
                          }}
                          style={style.priceRangeInputMax}
                        />
                      </Grid>
                    </Grid>

                  </Grid>


                  <Grid data-test-id={"engmtflt-btn"} item  xs={12}>
                    <Grid
                      container
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: 20,
                      }}
                    >
                      <Grid item>
                        <p style={style.label}>Engagement size</p>
                      </Grid>
                      <Grid item>
                        <Grid style={{ marginTop: 18 }}>
                          <input
                          data-test-id={"aengmtflt-btn"}
                            value={this.state.engagement}
                            style={style.priceRangeInput}
                            onChange={evt => {
                              let engagement = evt.target.value;
                              if (!engagement) {
                                this.setState({ engagement });
                                return;
                              }
                              if (engagement && engagement.length < 1) {
                                this.setState({ engagement });
                                return;
                              }

                              engagement = parseInt(engagement);

                              if (isNaN(engagement)) {
                                NotificationManager.error('Only numbers are allowed', 'Chef filters');
                                engagement = 1;
                              }

                              this.setState({ engagement });
                            }}
                            onBlur={() => {
                              let { engagement } = this.state;

                              if (!engagement) {
                                this.setState({ engagement: 1 });
                                return;
                              }
                              if (engagement.length < 1) {
                                this.setState({ engagement: 1 });
                                return;
                              }

                              engagement = parseInt(engagement);

                              if (isNaN(engagement)) {
                                NotificationManager.error('Only numbers are allowed', 'Chef filters');
                                engagement = 1;
                              }

                              if (engagement < 1) {
                                NotificationManager.error('Engagement size cannot be less than 1', 'Chef filters');
                                engagement = 1;
                              }

                              this.setState({ engagement });
                            }}
                          />
                          <span>diners</span>
                        </Grid>
                        {/*<p style={style.value}>
                          {this.state.engagement} diners
                        </p>*/}
                      </Grid>
                    </Grid>

                    {/*<InputField
                      name={"engagement"}
                      hideLabel
                      error={errors.engagement && touched.engagement}
                      errorMessage={errors.maxTravelDistance}
                      type={"slider"}
                      onSliderValueChange={this.handleEngagementChange}
                      defaultValue={this.state.engagement}
                    />*/}
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    style={{marginTop: 50, textAlign: "center"}}>
                    {/*<Button
                      data-test-id={"chefapplyfilters"}

                      variant={"contained"}
                      color={"primary"}
                      style={{
                        width: 240,
                        height: 48,
                        fontFamily: webFont,
                        fontSize: 18,
                        borderRadius: 24,
                        textTransform: "none",
                        color: " #ffffff"
                      }}
                      onClick={() => this.applyFilters()}
                    >
                      Apply filters
                    </Button>*/}
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </Grid>
      </Grid>
    );
  }
}

const mapStateToProps = state => {
  return {
    chefFilters: state.chefs.filters
  };
};
const ChefsFilters = connect(mapStateToProps)(ChefFilters);

export default ChefsFilters;

const style = {
  value: {
    fontFamily: webFont,
    fontSize: 18,
    color: primaryColor
  },
  label: {
    fontFamily: webFont,
    fontSize: 18
  },
  priceLabel: {
    fontFamily: webFont,
    fontSize: 18,
    marginRight: 5
  },
  toLabel: {
    fontFamily: webFont,
    fontSize: 18,
    marginRight: 5,
    marginLeft: 5
  },
  priceRangeInput: {
    width: 40,
    border: 'none',
    fontFamily: webFont,
    fontSize: 16,
    borderBottomWidth: 1,
    borderBottomColor: primaryColor,
    borderBottomStyle: 'solid',
    outline: 'none',
    textAlign: 'center'
  },
  priceRangeInputMax: {
    width: 50,
    border: 'none',
    fontFamily: webFont,
    fontSize: 16,
    borderBottomWidth: 1,
    borderBottomColor: primaryColor,
    borderBottomStyle: 'solid',
    outline: 'none',
    textAlign: 'center'
  }
};
